import { render } from "./ImageInput.vue?vue&type=template&id=1524ba83&scoped=true&ts=true"
import script from "./ImageInput.ts?vue&type=script&lang=ts"
export * from "./ImageInput.ts?vue&type=script&lang=ts"

import "./ImageInput.vue?vue&type=style&index=0&id=1524ba83&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1524ba83"]])

export default __exports__